import { BakeryEvent } from '../types/event'

// Halloween · vecka 44 · 26 okt – 1 nov 2026 (slutgiltigt schema)
export const events: BakeryEvent[] = [
  {
    id: 'halloween-start',
    title: 'Halloweenveckan drar igång!',
    date: '2026-10-26',
    description:
      'Vi tänder ljusen, pyntar vår servering och fyller diskarna med spökligt goda nyheter. Kom och känn Halloweenstämningen hos oss!',
  },
  {
    id: 'halloween-run-club',
    title: 'Run Club & Pinsa AW',
    date: '2026-10-27',
    time: '18.00',
    description:
      'För vuxna som gillar rörelse, gemenskap och riktigt god mat! Vi springer tillsammans med Tuesday Run Club runt Växjösjön och avslutar med en härlig pinsabuffé och ett glas bubbel på Top Notch.',
    highlight: {
      title: 'Pinsa AW',
      text: 'Vi dukar upp en rejäl pinsabuffé med massor av god dryck och härlig stämning. Har du sprungit med på dagens Run Club får du 20 % rabatt.',
    },
    signup: true,
  },
  {
    id: 'halloween-hidden-reality',
    title: 'Top Notch Hidden Reality',
    date: '2026-10-28',
    time: '17.00',
    description:
      'En unik kväll där verklighet och fantasi möts. Boka in dig på en kväll med pinsa, god dryck och ett mordmysterium att lösa. Du kan boka ett helt spel för ditt eget sällskap. Du kan också välja ett öppet spel, där vi parar ihop er med ett annat gäng. Det passar perfekt om ni är två personer.',
    signup: true,
  },
  {
    id: 'halloween-barnens-dag',
    title: 'Barnens dag',
    date: '2026-10-29',
    time: '11.00–13.00',
    secondaryTime: 'Lopp 13.30',
    description:
      'Vi tar över vår ovanvåning för alla små monster! Här väntar våffelbuffé, ansiktsmålning, fotobås och halloweenmålning. Dagen avslutas med ett Halloweenlopp för alla barn som vill vara med. Vi springer ett gemensamt lopp i halloweenkostymer, och i mål väntar ett efterlängtat godisregn!',
    signup: true,
  },
  {
    id: 'halloween-monsterdisko',
    title: 'Monsterdisko för barnen',
    date: '2026-10-30',
    time: '18.00–20.00',
    description:
      'Efter Växjö Citys Zombiewalk fortsätter festen på Top Notch! Dans, musik och massor av Halloweenstämning.',
    signup: true,
  },
  {
    id: 'halloween-pa-top-notch',
    title: 'Top Notch halloween',
    date: '2026-10-31',
    description:
      'Självaste Halloween! En dag fylld med spökliga överraskningar, goda smaker och härlig stämning. Kom gärna utklädd och upplev en magisk dag hos oss!',
    signup: true,
  },
  {
    id: 'halloween-hostbrunch',
    title: 'Höstbrunch',
    date: '2026-11-01',
    time: '11.00–15.00',
    description:
      'Vi avslutar Halloweenveckan med en mysig höstbrunch. Njut av god mat, härlig stämning och den perfekta avslutningen på en spökligt bra vecka!',
    signup: true,
    ctaLabel: 'Boka bord',
  },
]
